import { ApiClient } from "./ApiClient";

/**
 * Fetch notifications for the current user
 * @param {string} url - The dynamic endpoint path (e.g., 'notifications/notification')
 * @returns {Promise<Response>}
 */
export const fetchNotificationList = async (url) => {
  // ApiClient.get handles the baseUrl and credentials.
  return ApiClient.get(url);
};

/**
 * Mark a notification as read (Status: CHE)
 * @param {string|number} notificationId - ID of the notification
 * @param {string} model_type - The backend model type identifier
 * @returns {Promise<Response>}
 */
export const markNotificationAsRead = async (notificationId, model_type) => {
  const payload = {
    model_type: model_type,
    fields: { status: "CHE" },
  };

  // ApiClient.put handles the JSON stringification and CSRF
  return ApiClient.put(
    `/notifications/notification/${notificationId}`,
    payload,
  );
};

/**
 * Delete a specific notification
 * @param {string|number} notificationId - ID of the notification
 * @param {string} model_type - The backend model type identifier
 * @returns {Promise<Response>}
 */
export const deleteNotification = async (notificationId, model_type) => {
  // Ensure model_type isn't undefined here
  console.log("Deleting with model_type:", model_type);

  const payload = { model_type: model_type };

  return ApiClient.delete(
    `/notifications/notification/${notificationId}`,
    payload,
  );
};

export const fetchNoticationList = fetchNotificationList;
